// Export configuration
export * from "./config/index.js";
// Export constants
export * from "./constants/index.js";
// Export utilities
export * from "./utils/index.js";
// Export types
export * from "./types/index.js";
// Generate and export paths for app config
import { appConfigMeta } from "./config/index.js";
import { generatePaths } from "./utils/index.js";
export const appConfigPaths = generatePaths(appConfigMeta);
//# sourceMappingURL=index.js.map